export const requestAnimationFrameInit = ():void => {
	let lastTime = 0
	const vendors = ['webkit', 'moz']
	for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame']
		window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame']
	}
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = (callback:Function) => {
			const currTime = new Date().getTime()
			const timeToCall = Math.max(0, 16 - (currTime - lastTime))
			const id = window.setTimeout(() => {
				const _time = currTime + timeToCall
				callback(_time)
			}, timeToCall)
			lastTime = currTime + timeToCall
			return id
		}
	}
	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = id => {
			clearTimeout(id)
		}
	}
}

export const fxRequestAnimationFrame = function (fn:Function):number {
	if (!window.requestAnimationFrame) {
		requestAnimationFrameInit()
	}
	const fxRef = window.requestAnimationFrame
	return fxRef.call(window, fn as FrameRequestCallback)
}

export const cancelAnimationFrame = function (id:number):void {
	if (!window.requestAnimationFrame) {
		requestAnimationFrameInit()
	}
	const cacel = window.cancelAnimationFrame
	return cacel.call(window, id)
}

